// extracted by mini-css-extract-plugin
export default {"promoBanner":"bm_gZ","visible":"bm_g0","hidden":"bm_f2","promoText":"bm_g1","visitButton":"bm_g2","closeIcon":"bm_g3"};